import React from 'react';
import { IconButton, Paper } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import BrokenImage from '@material-ui/icons/BrokenImage';
import { LoadingBounce } from '@michelin/acid-components';
import { APPS, useGetAccessToken } from '@michelin/central-provider';
import { useRenderableImage } from '@michelin/maestro-file-upload';

interface BrandImageProps {
  imageName: string;
  imageSize?: string;
}
export const BrandImage = (props: BrandImageProps) => {
  const { imageName, imageSize = '100px' } = props;
  const accessToken = useGetAccessToken();

  const { src, error, loading } = useRenderableImage({
    bearer: `Bearer ${accessToken ?? ''}`,
    // TODO: manage env vars better
    image: `${process.env.REACT_APP_API_MAESTRO_FILE_UPLOAD ?? ''}/${APPS.CATALOG}/brand/${imageName}`,
  });
  const broken = React.useMemo(
    () => (
      <Box p={2} width={imageSize}>
        <IconButton size="small" color="default" style={{ pointerEvents: 'none', opacity: '0.2' }}>
          <BrokenImage />
        </IconButton>
      </Box>
      // eslint-disable-next-line react-hooks/exhaustive-deps
    ),
    [imageSize],
  );
  if (imageName) {
    if (error) return broken;
    return (
      <Paper
        style={{
          padding: 8,
          width: imageSize,
          overflow: 'hidden',
          backgroundColor: 'white',
        }}
        elevation={0}
      >
        {loading ? <LoadingBounce /> : <img src={src} alt={`${imageName}`} style={{ width: '100%' }} />}
      </Paper>
    );
  }
  return broken;
};
